import { useState } from "react";
import { EDITION_PLAN_SALON, type Entite, type StandSalon } from "@hopitech/contracts";
import { apiGet } from "../lib/api.ts";

export function QrStand({ exposant }: { exposant: Entite }): React.ReactElement | null {
  const [resultat, setResultat] = useState<{ qr: string; url: string; stand: StandSalon }>();
  const [erreur, setErreur] = useState("");
  const [chargement, setChargement] = useState(false);
  if (exposant.edition !== EDITION_PLAN_SALON) return null;
  async function ouvrir(): Promise<void> {
    setChargement(true); setErreur(""); setResultat(undefined);
    try { setResultat(await apiGet(`/api/salon/${exposant.edition}/qr/${encodeURIComponent(exposant.id)}`)); }
    catch (e) { setErreur(e instanceof Error ? e.message : "QR indisponible."); }
    finally { setChargement(false); }
  }
  return <div>
    <button className="btn btn-ghost" disabled={chargement} onClick={() => void ouvrir()}>{chargement ? "Chargement…" : "QR pour les visiteurs"}</button>
    {erreur && <p role="alert">{erreur}</p>}
    {resultat && <div style={{ display: "grid", gap: 10, maxWidth: 300 }}>
      <strong>{resultat.stand.nom} · {resultat.stand.emplacement}</strong>
      <img src={resultat.qr} width={240} height={240} alt={`QR de visite du stand ${resultat.stand.emplacement}`} />
      <a className="btn btn-primary" href={resultat.qr} download={`hopitech-2026-${resultat.stand.emplacement}.png`}>Télécharger le QR</a>
      <a href={resultat.url}>Ouvrir le parcours visiteur</a>
      <button className="btn btn-ghost" onClick={() => setResultat(undefined)}>Fermer</button>
    </div>}
  </div>;
}
